// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserListMenu-cls1__e7b3f93846db648e7038{/*!*/}.UserListMenu-cls2__d46f1c9af3dcb274a728{display:flex;align-items:center;justify-content:center;width:240px;height:52px}@media(min-width: 768px){.UserListMenu-cls2__d46f1c9af3dcb274a728{width:320px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserListMenu-cls1__e7b3f93846db648e7038",
	"cls2": "UserListMenu-cls2__d46f1c9af3dcb274a728 UserListMenu-cls1__e7b3f93846db648e7038"
};
export default ___CSS_LOADER_EXPORT___;
